export default "__VITE_ASSET__DTJGbb37__"